import { Copy, Pencil, ThumbsDown, ThumbsUp } from "lucide-react";
import "./WazawanResponseToolbar.css";
import { PromptPair } from "./Wazawan";
import { handleCopyText } from "../uiHelpers";
import { toastSuccess } from "../../config";
import toast from "react-hot-toast";

type WazawanResponseToolbarProps = {
    promptPair: PromptPair;
};

export const WazawanResponseToolbar = ({promptPair}: WazawanResponseToolbarProps) => {

    const handleCopy = async () => {
        console.log("Copy");
        handleCopyText(promptPair.response);
    }

    return (
        <div className="wazawan-response-toolbar">
            <div 
                className="wazawan-response-toolbar-item"
                onClick={handleCopy}
            >
                <Copy size={16} />
            </div>
            <div 
                className="wazawan-response-toolbar-item"
                onClick={() => toast("Thanks for the feedback!", toastSuccess)}
            >
                <ThumbsUp size={16}/>
            </div>
            <div 
                className="wazawan-response-toolbar-item"
                onClick={() => toast("Thanks for the feedback!", toastSuccess)}
            >
                <ThumbsDown size={16}/>
            </div>
            <div className="wazawan-response-toolbar-item">
                <Pencil size={16}/>
            </div>
        </div>
    )
}